const ONLINE_ONLY_ROLE = 'online-only'
// The raw `_users` doc stores this unprefixed, but the web client normalises
// any role not on its allow-list to `feature:<role>` at login
// (api/lib/utils/normalise-roles.js) — so a browser-sourced `state.user`
// actually carries `feature:online-only`, while a server/lambda-sourced
// `state.user` (never normalised, e.g. inside agave) still has the raw
// `online-only`. Check both so resolveSource works from either context.
const ONLINE_ONLY_ROLES = [ONLINE_ONLY_ROLE, `feature:${ONLINE_ONLY_ROLE}`]

// resolveSource({ user }) -> 'agave' | 'legacy'
//
// The binary data-source decision. 'agave' means always agave. 'legacy' means
// whatever the calling domain already does today, unchanged by this resolver —
// local pouch, remote couch, or an existing ad-hoc agave fallback, depending on
// the domain. Centralising the decision here means later policies (inverting
// the default to online-first, connection-aware reads) only ever change this
// one function.
//
// Phase 1 policy: an online-only user reads/writes everything through agave,
// everyone else stays on the legacy path. The answer is the same for every
// domain, so the resolver takes no domain argument; add one when a policy
// actually needs to vary by domain.
function resolveSource ({ user } = {}) {
  const isOnlineOnly = !!(user && user.roles && ONLINE_ONLY_ROLES.some(role => user.roles.includes(role)))
  return isOnlineOnly ? 'agave' : 'legacy'
}

module.exports = { resolveSource, ONLINE_ONLY_ROLE }
